import React, { useState } from "react";
import { useField } from "formik";
import { Button, FormFeedback, FormGroup, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
// import { FormattedMessage } from 'react-intl';
import PasswordHint from '../../../components/common/PasswordHint';

const TextInput = (props) => {
	const [field, meta] = useField(props.name);
	const [show, setShow] = useState(false)

	return (
		<FormGroup className={`input-wrapper ${props?.className}`}>
			{props.label && <>
				<label htmlFor={props?.id} >
					<span className={props.isRequired && 'required'}>{props.label}</span>
				</label>
			</>
			}

			<div className={`input-cell position-relative ${props.isIcon ? 'input-icon' : ''}`}>
				<Input
					{...field}
					{...props}
					//   className={`${props?.inputClass}`}
					autoComplete="off"
					onFocus={() => setShow(true)}
					onBlur={() => setShow(false)}
				/>

				{props.isIcon &&
					<Button
						type='button'
						color="link"
						className="position-absolute right-side-icon p-0"
						onClick={props.togglePassword}
					>
						{props.passwordType === "password" ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
					</Button>
				}

				{
					show ? props.passwordHint &&
						<PasswordHint /> : null
				}

			</div>

			{meta.touched && meta.error && (
				<FormFeedback className="d-block"> {meta?.error}
					{/* <FormattedMessage id={meta.error} values={{
            name: props?.placeholder || 'This'
          }} /> */}
				</FormFeedback>
			)}
		</FormGroup>
	);
};
export default TextInput;